import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import useStyles from '@containers/checkout/payment-success/styles';
// import { Divider } from '@material-ui/core';
import useBreakpoints from '@hooks/useBreakpoints';
// import CreateAccount from '@components/CreateAccount';
import { sendEvent } from '@utils/ga';
import { ACTIONS, CATEGORIES } from '@constants/analytics';
import useStore from '@hooks/useStore';
// import handleRedirect from '@utils/handleRedirect';
// import Button from '@material-ui/core/Button';
import PaymentSuccessGraphics from '@components/PaymentSuccessfulGraphics';
import { PaymentLinkStatus, PAYMENT_LINK_PAYMENT_METHODS } from '@constants/paymentLink';

const PaymentSuccess: React.FunctionComponent = () => {
  const {
    links: {
      coBrandingConfig: { primaryColor },
    },
  } = useStore();
  const css = useStyles({ primaryColor });
  const { t } = useTranslation();
  const { isTouchScreen } = useBreakpoints();
  const { checkout, links } = useStore();
  const { paymentLink } = links;
  const { settings, isSubscription, status, paymentMethod } = paymentLink;

  const onCreateAccountClick = () => {
    sendEvent({
      category: CATEGORIES.CHECKOUT.CATEGORY,
      action: ACTIONS.CLICK,
      label: CATEGORIES.CHECKOUT.LABELS.SUCCESS_SCREEN_CTA,
    });
  };

  const isSubscriptionCanceled = status === PaymentLinkStatus.SUBSCRIPTION_CANCELED;
  const isSubscriptionPendingActivation = status === PaymentLinkStatus.PENDING_ACTIVATION;
  const isDirectDebit = paymentMethod === PAYMENT_LINK_PAYMENT_METHODS.DIRECT_DEBIT;

  const handleRedirect = () => {
    if (settings?.redirectAuto === 'true') {
      window.location.replace(settings?.redirectUrl);
    }
  };

  const isCardPaymentSuccess = checkout.success.cardPayment;
  const isDirectDebitPaymentSuccess = checkout.success.directDebitPayment;
  const handleCardPaymentSuccess = () => {
    handleRedirect();
    links.setAsPaid();
  };

  const redirect = () => handleRedirect();

  useEffect(() => {
    if (isCardPaymentSuccess || isDirectDebitPaymentSuccess) return handleCardPaymentSuccess();
  }, [isCardPaymentSuccess, isDirectDebitPaymentSuccess]);

  return (
    <div className={css.root}>
      {!isSubscriptionCanceled && (
        <>
          <h2 className="payment-success-title">
            {!isSubscription
              ? t('checkoutScreen.payment.success.title')
              : !isSubscriptionPendingActivation
              ? t('checkoutScreen.subscription.success.title')
              : t('checkoutScreen.subscription.pending.title')}
          </h2>
          <div className="payment-success-message">
            {!isSubscription
              ? t('checkoutScreen.payment.success.message')
              : !isSubscriptionPendingActivation
              ? isDirectDebit
                ? t('checkoutScreen.subscription.success.directDebitMessage')
                : t('checkoutScreen.subscription.success.message')
              : t('checkoutScreen.subscription.pending.message')}
          </div>
        </>
      )}
      {isSubscriptionCanceled && (
        <>
          <h2 className="payment-success-title">
            {t('checkoutScreen.subscription.canceled.title')}
          </h2>
          <div className="payment-success-message">
            {t('checkoutScreen.subscription.canceled.message')}
          </div>
        </>
      )}
      <div className="payment-success-image-container">
        <PaymentSuccessGraphics fill={primaryColor} />
      </div>
      {/*
      <Divider hidden={isTouchScreen} />
      <CreateAccount hidden={isTouchScreen} onClick={onCreateAccountClick} />
      {!checkout.shouldAutoRedirect && (
        <Button
          data-testid="continue-button"
          onClick={redirect}
          className={css.continueButton}
          fullWidth
          color="primary"
        >
          {t('checkoutScreen.payment.success.goBack')}
        </Button>
      )}
      */}
    </div>
  );
};

export default observer(PaymentSuccess);
